import { useEffect, useRef, useState } from 'react';

const DEFAULT_HEIGHT = 150;
const DEBOUNCE_MS = 100;

export function useInputSectionMetrics(resetKey) {
    const inputSectionRef = useRef(null);
    const [inputSectionHeight, setInputSectionHeight] = useState(DEFAULT_HEIGHT);

    useEffect(() => {
        const inputSection = inputSectionRef.current;
        if (!inputSection) return undefined;

        let debounceTimer = null;

        const updateHeight = () => {
            const height = inputSection.offsetHeight;
            if (height > 0) setInputSectionHeight(height);
        };

        const debouncedUpdate = () => {
            if (debounceTimer) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(updateHeight, DEBOUNCE_MS);
        };

        updateHeight();
        const postMountTimer = setTimeout(updateHeight, DEBOUNCE_MS);

        const resizeObserver = new ResizeObserver(debouncedUpdate);
        resizeObserver.observe(inputSection);

        return () => {
            clearTimeout(postMountTimer);
            if (debounceTimer) clearTimeout(debounceTimer);
            resizeObserver.disconnect();
        };
    }, [resetKey]);

    return { inputSectionRef, inputSectionHeight };
}
